import React from "react";
import "../NewsletterConfirmation/style.scss";
import "../../../style/alerts.scss";
import { passValidator } from "../../../utils/formsValidation";
import useChangePasswordForm, { CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_WAITING } from "./useChangePasswordForm";
import { Grid, Paper } from "@mui/material";
import FormInput from "../../../utils/FormInput";
import { useTranslation } from "react-i18next";
import { LOGIN_PAGE } from "../../routes";
import { Link } from "react-router-dom";
import EAButton from "../shared/Buttons/EAButton";

const ChangePasswordForm: React.FC = () => {
  const { t } = useTranslation();
  const { status, onConfirm, register, handleSubmit, errors } = useChangePasswordForm();
  return (
    <React.Fragment>
      <Grid container sx={{ width: "100vw", height: "100vh" }} justifyContent="center" alignItems="center">
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 8, width: "88%" }}>
            <Grid container alignContent="space-evenly" justifyContent="center">
              <Grid item xs={12}>
                <h2 className="confirm-newsletter-title-centered">
                  {status === CHANGE_PASSWORD_SUCCESS ? "🎉 Hasło zmieniono pomyślnie" : "Zmień hasło"}
                </h2>
              </Grid>
              {status !== CHANGE_PASSWORD_SUCCESS ? (
                <form onSubmit={handleSubmit(onConfirm)}>
                  <Grid item xs={12}>
                    <FormInput
                      type={"password"}
                      name={"password"}
                      text={t("nowe_haslo")}
                      register={{ ...register("password", { ...passValidator(true) }) }}
                      errors={errors}
                      isLabel
                    />
                  </Grid>

                  <Grid item xs={12} >
                    <FormInput
                      type={"password"}
                      name={"repeatedPassword"}
                      text={t("potwierdz_nowe_haslo")}
                      register={{ ...register("repeatedPassword", { ...passValidator(true) }) }}
                      errors={errors}
                      isLabel
                    />
                  </Grid>

                  <Grid item>
                    {status !== CHANGE_PASSWORD_SUCCESS && status !== CHANGE_PASSWORD_WAITING && (
                      <div className="alert alert-red">*{status}</div>
                    )}
                  </Grid>

                  <Grid item>
                    <EAButton title="Zmień hasło" onClick={handleSubmit(onConfirm)} fullWidth />
                  </Grid>
                </form>
              ) : (
                <Grid item>
                  {status === CHANGE_PASSWORD_SUCCESS && (
                    <Link to={LOGIN_PAGE}>
                      <EAButton title="Zaloguj się" />
                    </Link>
                  )}
                </Grid>
              )}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default ChangePasswordForm;
